function ingredFaqInit() {
  const tabButtons = document.querySelectorAll(
    '.ingred-faq .ingredient-faq-main .ingredient-faq-button-main .product-faq-btn'
  );
  const tabs = document.querySelectorAll('.ingred-faq .ingredient-faq-main .questions-wrapper > div');
  if (tabButtons.length > 0 && tabs.length > 0) {
    tabButtons[0]?.classList.add('active');
    tabs[0]?.classList.add('active');
    tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (button.classList.contains('active')) return;

        const clickedProduct = button.getAttribute('data-product');
        const activeButton = document.querySelector(
          '.ingred-faq .ingredient-faq-main .ingredient-faq-button-main .product-faq-btn.active'
        );

        const activeTab = document.querySelector('.ingred-faq .ingredient-faq-main .questions-wrapper > div.active');
        const targetTab = document.querySelector(
          `.ingred-product-main.active .ingred-faq .ingredient-faq-main .questions-wrapper > div[data-product-for="${clickedProduct}"]`
        );

        if (activeTab && targetTab) {
          button.classList.add('active');
          activeButton?.classList.remove('active');
          activeTab?.classList.remove('active');
          targetTab?.classList.add('active');
        }
      });
    });
  }

  // FAQ accordion
  const faqQues = document.querySelectorAll(
    '.ingred-faq .ingredient-faq-main .questions-wrapper>div .faq-quesntion-main .question'
  );

  if (faqQues.length > 0) {
    faqQues.forEach((que) => {
      que.addEventListener('click', (e) => {
        e.preventDefault();
        const answer = que.nextElementSibling;
        if (!answer) return;

        const activeAnswer = document.querySelector(
          '.ingred-faq .ingredient-faq-main .questions-wrapper > div.active .answer.active'
        );
        // Close other open answer (if it's not the same one)
        if (activeAnswer && activeAnswer !== answer) {
          activeAnswer.style.maxHeight = null;
          activeAnswer.classList.remove('active');
        }

        // Toggle current answer
        if (answer.classList.contains('active')) {
          answer.style.maxHeight = null;
          answer.classList.remove('active');
        } else {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          answer.classList.add('active');
        }
      });
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.ingred-main .products-ingred .product-buttons-main button');
  const tabs = document.querySelectorAll('.ingred-main .product-ingred-details-tab .ingred-product-main');
  if (tabButtons.length > 0 && tabs.length > 0) {
    tabButtons[0]?.classList.add('active');
    tabs[0]?.classList.add('active');
    tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (button.classList.contains('active')) return;

        const clickedProduct = button.getAttribute('data-product');
        const activeButton = document.querySelector(
          '.ingred-main .products-ingred .product-buttons-main button.active'
        );

        const activeTab = document.querySelector(
          '.ingred-main .product-ingred-details-tab .ingred-product-main.active'
        );
        const targetTab = document.querySelector(
          `.ingred-main .product-ingred-details-tab .ingred-product-main[data-for-product="${clickedProduct}"]`
        );

        if (activeTab && targetTab) {
          button.classList.add('active');
          activeButton?.classList.remove('active');
          activeTab?.classList.remove('active');
          targetTab?.classList.add('active');
          targetTab.querySelector('.ingredient-faq-button-main .product-faq-btn')?.click();
        }
      });
    });
  }
  ingredFaqInit();
});
